import { render, staticRenderFns } from "./AdRankIcon.vue?vue&type=template&id=2bd41739&scoped=true"
import script from "./AdRankIcon.vue?vue&type=script&lang=js"
export * from "./AdRankIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd41739",
  null
  
)

export default component.exports